import styles from "./styles.module.css";

export default function WatermarkOOGLON() {
  return (
    <a href="https://ooglon.com" target="_blank" className={styles.container}>
      Maquete Virtual OOGLON&#174;
    </a>
  );
}
